import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { i18n } from '@/common/locale';
import { requireAuth } from '@/common/router/navigationGuard';
import { downloadByUrl } from '@/common/utils/commonUtils';
import { RouteRecordRaw } from 'vue-router';
import { VIEW_MODE } from '@/common/define/common.define';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';

const PREFIX_HELP = 'help_';

const helpMenu: RouteRecordRaw[] = [
  {
    path: '/tutorial/',
    name: `${PREFIX_HELP}Tutorial`,
    component: BaseViewport,
    beforeEnter: requireAuth,
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_USER_MANUAL,
      viewport: VIEWPORT_TYPE.SETTING,
    },
    children: [
      {
        path: 'dashboard',
        name: `${PREFIX_HELP}Dashboard`,
        component: () => import('../views/tutorial/TutorialView.vue'),
      },
      {
        path: 'infrastructure',
        name: `${PREFIX_HELP}Infrastructure`,
        component: () => import('../views/tutorial/TutorialView.vue'),
      },
      {
        path: 'cloud',
        name: `${PREFIX_HELP}Cloud`,
        component: () => import('../views/tutorial/TutorialView.vue'),
        meta: {
          invisibleViewMode: [VIEW_MODE.INTERMAX],
        },
      },
      {
        path: 'kubernetes',
        name: `${PREFIX_HELP}Kubernetes`,
        component: () => import('../views/tutorial/TutorialView.vue'),
        meta: {
          invisibleViewMode: [VIEW_MODE.MAXGAUGE, VIEW_MODE.INTERMAX],
        },
      },
      {
        path: 'application',
        name: `${PREFIX_HELP}Application`,
        component: () => import('../views/tutorial/TutorialView.vue'),
        meta: {
          invisibleViewMode: [VIEW_MODE.MAXGAUGE],
        },
      },
      {
        path: 'database',
        name: `${PREFIX_HELP}Database`,
        component: () => import('../views/tutorial/TutorialView.vue'),
        meta: {
          invisibleViewMode: [VIEW_MODE.INTERMAX],
        },
      },
      {
        path: 'analysis',
        name: `${PREFIX_HELP}Analysis`,
        component: () => import('../views/tutorial/TutorialView.vue'),
        meta: {
          invisibleViewMode: [VIEW_MODE.INTERMAX],
        },
      }, // NOTE: 메뉴 숨김
    ],
  },
  // Note: 매뉴얼 내부 이미지들이 모두 클릭업에 있음
  // {
  //   path: '/support/',
  //   // ## NOTE 같은 이름 사용하는거 있으니 추후에 확인할 것..
  //   name: `${PREFIX_HELP}HELP.MANUAL`,
  //   children: [
  //     // 준비중 이라 스펙에서 제외
  //     // {
  //     //   path: 'faq',
  //     //   name: `${PREFIX_HELP}HELP.FAQ`,
  //     //   redirect: '',
  //     // },
  //     {
  //       path: 'product-introduction',
  //       name: `${PREFIX_HELP}HELP.PRODUCT_INTRODUCTION_DOWNLOAD`,
  //       beforeEnter: (to, from, next) => {
  //         const { t, locale } = i18n.global;
  //         downloadByUrl(
  //           `/support/${locale.value}/product_introduction.pdf`,
  //           `exemONE_${t('WORD.PRODUCT_INTRODUCTION')}.pdf`,
  //         );
  //         next(false);
  //       },
  //       children: [],
  //       meta: { icon: 'icon-download' },
  //     },
  //     {
  //       path: 'user-guide',
  //       name: `${PREFIX_HELP}HELP.USER_GUIDE_DOWNLOAD`,
  //       beforeEnter: (to, from, next) => {
  //         const { t, locale } = i18n.global;
  //         downloadByUrl(
  //           `/support/${locale.value}/user_guide.pdf`,
  //           `exemONE_${t('WORD.USER_GUIDE')}.pdf`,
  //         );
  //         next(false);
  //       },
  //       children: [],
  //       meta: { icon: 'icon-download' },
  //     },
  //   ],
  // },
  {
    path: '/guide/',
    name: `${PREFIX_HELP}HELP.GUIDE`,
    beforeEnter: requireAuth,
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_USER_MANUAL,
    },
    children: [
      {
        path: 'exemone-manual',
        name: `${PREFIX_HELP}HELP.EXEMONE_MANUAL`,
        beforeEnter: (to, from, next) => {
          const { t } = i18n.global;
          downloadByUrl(
            '/support/exemOne_maxgauge_manual.pdf',
            `exemONE_${t('WORD.EXEMONE_MANUAL')}.pdf`,
          );
          next(from);
        },
        children: [],
        meta: {
          menuIcon: 'icon-download',
          menuIconLabel: i18n.global.t('WORD.DOWNLOAD'),
          invisibleViewMode: [VIEW_MODE.EXEMONE, VIEW_MODE.INTERMAX, VIEW_MODE.CLOUDMOA],
          noMenuSelect: true,
        },
      },
      {
        path: 'openapi-guide',
        name: `${PREFIX_HELP}HELP.OPENAPI_GUIDE`,
        beforeEnter: (to, from, next) => {
          const { t } = i18n.global;
          downloadByUrl(
            '/support/exemOne_openapi_guide.pdf',
            `exemONE_${t('WORD.OPENAPI_GUIDE')}.pdf`,
          );
          next(from);
        },
        children: [],
        meta: {
          menuIcon: 'icon-download',
          menuIconLabel: i18n.global.t('WORD.DOWNLOAD'),
          noMenuSelect: true,
        },
      },

      // {
      //   path: 'exemone-docs',
      //   name: `${PREFIX_HELP}HELP.MANUAL`,
      //   beforeEnter: (to, from, next) => {
      //     window.open(EXEM_ONE_DOCS_LINK, '_blank', 'noopener,noreferrer');
      //     next(false); // 실제 라우트 전환은 막음
      //   },
      //   children: [],
      //   meta: {
      //     icon: 'ev-icon-external-link3',
      //     iconClass: 'right-panel-sub-menu__help-manual-icon',
      //   },
      // },
    ],
  },
  {
    path: '/libraryNotation/',
    name: `${PREFIX_HELP}HELP.LIBRARY_NOTATION`,
    component: BaseViewport,
    beforeEnter: requireAuth,
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_USER_MANUAL,
      viewport: VIEWPORT_TYPE.SETTING,
    },
    children: [
      {
        path: 'license',
        name: `${PREFIX_HELP}HELP.OPEN_LICENSE`,
        component: () => import('../views/libraryNotation/LicenseView.vue'),
      },
    ],
  },
];

const getHelpNaviMenu = () => [...helpMenu];

export { helpMenu, getHelpNaviMenu };
